const main = () => {
    const modal = document.querySelector('[data-build-area-modal]');
    if (modal === null) return;

    const triggers = document.querySelectorAll('[data-open-build-modal]');
    if (triggers.length === 0) return;

    const open = () => {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));
    };

    const close = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    };

    const toggle = () => {
        if (modal.classList.contains('is-open')) {
            close();
        } else {
            open();
        }
    };

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle();
        });
    });

    // モーダル外クリックで閉じる（黒透過オーバーレイ=modal自身のクリックを含む）
    document.addEventListener('click', (e) => {
        if (!modal.classList.contains('is-open')) return;
        if (modal.contains(e.target) && e.target !== modal) return;
        if ([...triggers].some((t) => t.contains(e.target))) return;
        close();
    });

    // Escキーで閉じる
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            close();
        }
    });
};

export default main;
